import React from "react";
import { FormFeedback, FormGroup, Input, Label } from "reactstrap";

const CustomInput = ({
  type,
  name,
  id,
  placeholder,
  handleChange,
  value,
  handleBlur,
  error,
  touched,
  label,
  required,
  onBlur,
  showlabel = true,
  ...props
}) => {
  return (
    <FormGroup>
      {showlabel && (
        <Label htmlFor="addressInput" className="form-label mb-0">
          {label}
          {required && <sup className="text-danger">*</sup>}
        </Label>
      )}
      <Input
        id={id}
        value={value}
        name={name}
        type={type ?? "text"}
        placeholder={placeholder}
        onChange={handleChange}
        onBlur={handleBlur}
        invalid={error && touched}
        {...props}
      />
      {error && touched && <FormFeedback>{error}</FormFeedback>}
    </FormGroup>
  );
};

export default CustomInput;
